import { Form, Select, InputNumber, Button, Space, Switch } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getPromotionById, updatePromotion } from '../../store/slices/promotionSlice';

const days = [
    'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'
];

const EditPromotion = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    useEffect(() => {
        fetchPromotion();
    }, []);

    const fetchPromotion = async () => {
        try {
            const result = await dispatch(getPromotionById(id));

            if (getPromotionById.fulfilled.match(result)) {
                form.setFieldsValue(result.payload);
            } else {
                setAlertMessage("Failed to load promotion");
            }
        } catch (err) {
            setAlertMessage("Error fetching promotion");
        }
    };

    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");

        try {
            const result = await dispatch(updatePromotion({ id, data: values }));

            if (updatePromotion.fulfilled.match(result)) {
                navigate('/promotion');
            } else {
                setAlertMessage(result?.payload?.error || 'Error updating promotion');
            }
        } catch (err) {
            setAlertMessage('Error updating promotion');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} onFinish={onSubmit} layout="vertical">
            <Form.Item
                name="day"
                label="Day"
                rules={[{ required: true }]}
            >
                <Select options={days.map(d => ({ label: d, value: d }))} />
            </Form.Item>

            <Form.Item
                name="discount_percent"
                label="Discount %"
                rules={[{ required: true }]}
            >
                <InputNumber min={1} max={100} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item
                name="is_active"
                label="Active Status"
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>

            {alertMessage && (
                <p style={{ color: 'red' }}>{alertMessage}</p>
            )}

            <Form.Item>
                <Space style={{ width: '100%' }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        size="large"
                        block
                        style={{
                            height: '48px',
                            fontSize: '16px',
                            fontWeight: 600,
                            borderRadius: '8px',
                        }}
                    >
                        Update
                    </Button>

                    <Button onClick={() => navigate(-1)}>
                        Back
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
};

export default EditPromotion;